export const NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException";
export const INVALID_PARAMETER_EXCEPTION = "InvalidParameterException";
export const MFA_SETUP_PARAMETER_EXCEPTION = "MfaSetupParameterException";
export const USER_NOT_FOUND = "UserNotFoundException";
export const EXPIRE_SESSION = "Invalid session for the user, session is expired.";
export const EXPIRE_MFA_SESSION = "Invalid session for the user.";
export const CODE_MISMATCH_EXCEPTION = "CodeMismatchException";
export const USER_DOESNT_HAVE_MARKET = "User doesn't have market";
export const NO_CURRENT_USER = "No current user";
export const USER_APP_TYPES_AVAILABILITY = "USER_APP_TYPES_AVAILABILITY";
export const USER_LAMBDA_VALIDATION_EXCEPTION = "UserLambdaValidationException";
export const USER_IS_INACTIVE = "USER_IS_INACTIVE";
